import { render, staticRenderFns } from "./CardWrapper.vue?vue&type=template&id=1624f838&scoped=true"
import script from "./CardWrapper.vue?vue&type=script&lang=ts"
export * from "./CardWrapper.vue?vue&type=script&lang=ts"
import style0 from "./CardWrapper.vue?vue&type=style&index=0&id=1624f838&prod&lang=scss"
import style1 from "./CardWrapper.vue?vue&type=style&index=1&id=1624f838&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1624f838",
  null
  
)

export default component.exports